import React from 'react';
import { useTheme } from '@emotion/react';

export default ({ colour }: { colour?: string }): JSX.Element => {
    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.59 22">
            <path
                d="M6.85 6.66c.18 1.17 1.14 2.12 2.37 2.35.12-.17.3-.28.52-.28.35 0 .64.29.64.64s-.29.64-.64.64c-.19 0-.35-.08-.47-.21-1.22.21-2.18 1.11-2.4 2.25.94.28 1.92.43 2.93.43 2.82 0 5.47-1.13 7.32-3.12-1.85-1.99-4.49-3.12-7.32-3.12-1.01 0-2.01.15-2.95.43Z"
                fill={colour || theme.colours.darkGray}
            />
            <path
                d="M8.32 9.4C7.24 8.94 6.44 8 6.23 6.87 4.8 7.4 3.51 8.23 2.48 9.35c1.04 1.12 2.33 1.95 3.77 2.48.24-1.09 1.03-1.98 2.07-2.43Z"
                fill={colour || theme.colours.darkGray}
            />
            <path
                d="M22.17 11.66c-.05-.06-.81-1.08-1.71-2.23.55-.62 1.19-1.44 1.79-2.41a2.237 2.237 0 0 0-3.8-2.36c-.4.65-.83 1.2-1.2 1.65-2.17-1.6-4.7-2.52-7.41-2.52-3.51 0-6.73 1.54-9.25 4.11-.78.8-.78 2.09 0 2.89 2.52 2.56 5.74 4.11 9.25 4.11 2.66 0 5.16-.89 7.31-2.44.78 1 1.42 1.86 1.43 1.87.44.59 1.11.9 1.8.9a2.236 2.236 0 0 0 1.79-3.57Zm-1.79 1.98c-.35 0-.64-.29-.64-.64 0-.1.03-.19.07-.27-.92-1.31-1.87-2.39-2.3-2.86-1.96 2.07-4.75 3.25-7.71 3.25-1.21 0-2.39-.2-3.49-.57h-.13v-.05c-1.68-.59-3.19-1.59-4.37-2.94l-.19-.21.19-.21C3.78 6.88 6.7 5.58 9.8 5.58s5.79 1.2 7.75 3.3c.39-.42 1.32-1.46 2.24-2.75a.681.681 0 0 1-.07-.28c0-.35.29-.64.64-.64s.64.29.64.64-.29.64-.64.64h-.03a29.56 29.56 0 0 1-2.38 2.92c.42.46 1.42 1.57 2.39 2.97h.04c.35 0 .64.29.64.64s-.29.64-.64.64Z"
                fill={colour || theme.colours.darkGray}
            />
        </svg>
    );
};
